/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * No image server for this datasource
 * @export
 * @interface GetAlliancesAllianceIdIconsNotFound
 */
export interface GetAlliancesAllianceIdIconsNotFound {
    /**
     * error message
     * @type {string}
     * @memberof GetAlliancesAllianceIdIconsNotFound
     */
    error?: string;
}

/**
 * Check if a given object implements the GetAlliancesAllianceIdIconsNotFound interface.
 */
export function instanceOfGetAlliancesAllianceIdIconsNotFound(value: object): value is GetAlliancesAllianceIdIconsNotFound {
    return true;
}

export function GetAlliancesAllianceIdIconsNotFoundFromJSON(json: any): GetAlliancesAllianceIdIconsNotFound {
    return GetAlliancesAllianceIdIconsNotFoundFromJSONTyped(json, false);
}

export function GetAlliancesAllianceIdIconsNotFoundFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAlliancesAllianceIdIconsNotFound {
    if (json == null) {
        return json;
    }
    return {
        
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function GetAlliancesAllianceIdIconsNotFoundToJSON(json: any): GetAlliancesAllianceIdIconsNotFound {
    return GetAlliancesAllianceIdIconsNotFoundToJSONTyped(json, false);
}

export function GetAlliancesAllianceIdIconsNotFoundToJSONTyped(value?: GetAlliancesAllianceIdIconsNotFound | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'error': value['error'],
    };
}

